import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';

/**
 * CSS 를 활용한 드롭다운
 * @see https://daisyui.com/components/dropdown/#method-3-css-focus
 */
export const Dropdown = Object.assign(
    observer(
        ({
            button,
            buttonClassName,
            contentClassName,
            direction,
            horizontal,
            children,
            preventCloseOnClick = false,
        }: {
            direction?: 'left' | 'right' | 'top' | 'bottom';
            horizontal?: 'start' | 'center' | 'end';
            button: React.ReactNode;
            buttonClassName?: string;
            contentClassName?: string;
            children: React.ReactNode;
            preventCloseOnClick?: boolean;
        }) => {
            return (
                <div
                    className={twMerge(
                        'dropdown',
                        // tailwind 빌드 되게 명시해둠
                        direction === 'top' && 'dropdown-top',
                        direction === 'bottom' && 'dropdown-bottom',
                        direction === 'left' && 'dropdown-left',
                        direction === 'right' && 'dropdown-right',
                        horizontal === 'start' && 'dropdown-start',
                        horizontal === 'center' && 'dropdown-center',
                        horizontal === 'end' && 'dropdown-end',
                    )}
                >
                    <div tabIndex={0} role="button" className={twMerge('btn', buttonClassName)}>
                        {button}
                    </div>
                    <div
                        tabIndex={0}
                        className={twMerge(
                            'dropdown-content bg-base-100 rounded-box z-1 w-full shadow-sm',
                            direction === 'top' && 'mb-1',
                            direction === 'bottom' && 'mt-1',
                            direction === 'left' && 'mr-1',
                            direction === 'right' && 'ml-1',
                            contentClassName,
                        )}
                        onClick={() => {
                            if (!preventCloseOnClick) {
                                // 클릭 시 포커스 해제
                                (document.activeElement as HTMLElement)?.blur();
                            }
                        }}
                    >
                        {children}
                    </div>
                </div>
            );
        },
    ),
    {},
);
